import { render, staticRenderFns } from "./WindowPortal.vue?vue&type=template&id=9771141c&scoped=true&"
import script from "./WindowPortal.vue?vue&type=script&lang=js&"
export * from "./WindowPortal.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "9771141c",
  null
  
)

export default component.exports